<template>
  <div class="breadcrumb">
    <div
      v-for="(page, index) in pages"
      :key="page.route"
      class="breadcrumb-container"
    >
      <p
        v-if="page.route === ''"
        class="item"
        :class="{ current: index === pages.length - 1 }"
      >
        <svg
          v-if="index > 0"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 19.328 34.43"
        >
          <path
            fill="#fff"
            fill-rule="evenodd"
            d="M18.71 15.72 3.66.62a2.178 2.178 0 0 0-3.041 0 2.178 2.178 0 0 0 0 3.041l13.555 13.555L.619 30.77a2.178 2.178 0 0 0 0 3.041 2.178 2.178 0 0 0 3.041 0l15.05-15.05a2.178 2.178 0 0 0 0-3.041Z"
          />
        </svg>
        {{ capitalize(page.title) }}
      </p>
      <NuxtLink
        v-else
        :to="page.route"
        class="item"
        :class="{ current: index === pages.length - 1 }"
      >
        <svg
          v-if="index > 0"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 19.328 34.43"
        >
          <path
            fill="#fff"
            fill-rule="evenodd"
            d="M18.71 15.72 3.66.62a2.178 2.178 0 0 0-3.041 0 2.178 2.178 0 0 0 0 3.041l13.555 13.555L.619 30.77a2.178 2.178 0 0 0 0 3.041 2.178 2.178 0 0 0 3.041 0l15.05-15.05a2.178 2.178 0 0 0 0-3.041Z"
          />
        </svg>
        {{ capitalize(page.title) }}
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ArianeRoute } from '~/types/arianeRoute'

defineProps<{
  pages: ArianeRoute[]
}>()
</script>

<style lang="scss" scoped>
.breadcrumb {
  position: sticky;
  top: 7rem;
  left: 0;
  z-index: 6;
  width: 100%;
  height: 3rem;
  padding: 0 2.5rem;
  overflow-x: auto;
  white-space: nowrap;
  background: $darkBackground;

  .breadcrumb-container {
    display: inline;

    p {
      display: inherit;
    }
  }

  @media (min-width: 700px) {
    padding: 0 0 0 8rem;
  }

  .item {
    color: $white;
    font-size: 1rem;
    line-height: 3rem;
    text-decoration: none;
    opacity: 0.3;

    svg {
      width: 0.3rem;
      height: 0.54rem;
      margin-right: 0.5rem;
      margin-left: 0.5rem;
    }

    &.current {
      opacity: 0.86;
    }
  }
}
</style>
